<template>
  <div id="contact">
    <section class="section section-lg">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">
              Contactez-nous
            </h2>
            <p class="lead">
              Besoin d'aide, de conseils ou d'information ? Notre équipe est à
              votre disposition du lundi au samedi, de 9h à 18h
            </p>

            <h4 class="display-5 mt-4">+229 40 36 14 53 | 51 73 65 24</h4>
            <p>contact@panneaumobile.co</p>

            <div class="text-center">
              <div class="row justify-content-center mt-4">
                <div class="col-lg-2 col-4">
                  <a
                    href="https://web.facebook.com/Panneau-Mobile-102579522053935"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <icon
                      name="fa fa-facebook-square"
                      class="mb-5"
                      size="lg"
                      type="success"
                      shadow
                      rounded
                    ></icon>
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://www.instagram.com/panneaumobile/"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <icon
                      name="fa fa-instagram"
                      class="mb-5"
                      size="lg"
                      type="success"
                      shadow
                      rounded
                    ></icon>
                  </a>
                </div>
                <div class="col-lg-2 col-4">
                  <a
                    href="https://twitter.com/MobilePanneau"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <icon
                      name="fa fa-twitter-square"
                      class="mb-5"
                      size="lg"
                      type="success"
                      shadow
                      rounded
                    ></icon>
                  </a>
                </div>

                <div class="col-lg-2 col-4">
                  <a
                    href="https://www.linkedin.com/in/panneau-mobile-68934a253"
                    target="_blank"
                    data-toggle="tooltip"
                  >
                    <icon
                      name="fa fa-linkedin-square"
                      class="mb-5"
                      size="lg"
                      type="success"
                      shadow
                      rounded
                    ></icon>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
};
</script>
<style></style>
